<!-- cabinet.component.html -->
@if (updateProfileForm) {
  <section class="flex flex-row gap-[1rem] h-auto overflow-hidden">
    <form
      class="flex flex-col w-[100%] gap-[1.25rem]"
      [formGroup]="updateProfileForm">
      <div class="main main-padding flex flex-col gap-[1rem]">
        <div class="flex flex-row gap-[1rem]">
          <app-upload #upload
                      data-qa="account-photo"
                      [oldImgSrc]="updateProfileForm?.value.photo"
                      [widthHeight]="'w-[14.17rem] h-[14.17rem]'"
                      (deleteOldLink)="updateProfileForm.patchValue({ photo: undefined })"
          />
          <div class="flex flex-col items-start gap-[1rem]">
            <!-- First row: Name, Company, Position, Phone -->
            <div class="flex flex-row items-center gap-[1.5rem]">
              <app-input
                data-qa="account-name"
                class="w-[18rem]"
                [required]="true"
                [formControl]="updateProfileForm.controls.name"
                [title]="'Name'"
                [placeholder]="'Name'"
                [maxLength]="256"
                [additionalClass]="updateProfileForm.controls.name.invalid ? 'error' : ''"
              />
              <app-input
                data-qa="account-company"
                class="w-[18rem]"
                [required]="true"
                [formControl]="updateProfileForm.controls.company"
                [title]="'Company'"
                [placeholder]="'Company'"
                [maxLength]="256"
                [additionalClass]="updateProfileForm.controls.company.invalid ? 'error' : ''"
              />
              <app-input
                data-qa="account-position"
                [required]="true"
                [formControl]="updateProfileForm.controls.position"
                class="w-[18rem]"
                [title]="'Position'"
                [placeholder]="'Position'"
                [maxLength]="256"
                [additionalClass]="updateProfileForm.controls.position.invalid ? 'error' : ''"
              />
              <app-input
                data-qa="account-phone"
                class="w-[18rem]"
                [required]="true"
                [formControl]="updateProfileForm.controls.phone"
                [title]="'Phone'"
                [placeholder]="'Phone'"
                [bottomText]="updateProfileForm.controls.phone.invalid && updateProfileForm.controls.phone.touched ? 'Please enter a valid phone number' : ''"
                [additionalClass]="updateProfileForm.controls.phone.invalid && updateProfileForm.controls.phone.touched ? 'error' : ''"
                (blurEmitter)="updateProfileForm.controls.phone.markAsTouched()"
              />
            </div>

            <!-- Second row: Work email -->
            <div class="flex flex-row items-center gap-[1.5rem]">
              <app-input
                data-qa="account-email"
                class="w-[18rem]"
                [formControl]="updateProfileForm.controls.email"
                [title]="'Work email'"
                [additionalClass]="'disabled'"
              />
            </div>

            <!-- Marketing checkbox -->
            <app-checkbox
              data-qa="account-marketing"
              [formControl]="updateProfileForm.controls.isMarketingAccepted"
              [checked]="updateProfileForm.value.isMarketingAccepted"
              (checkBoxClicked)="updateProfileForm.controls.isMarketingAccepted.setValue($event)">
              <span class="font-4 bold400 black-10">
                I agree to receive marketing communications from Orca and acknowledge that I can opt out at any time.
              </span>
            </app-checkbox>

            <!-- Save button -->
            <app-button
              data-qa="edit-main-info-button"
              [type]="'accent'"
              [size]="'small'"
              [additionalClasses]="'btn-width-5 text-center'"
              [disabled]="!this.updateProfileForm.valid"
              (buttonClick)="updateProfile()">
              Save
            </app-button>
          </div>
        </div>
      </div>
    </form>
  </section>
}
